import React, { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { destroyAllReactCarousels } from '../Utils/carouselHelpers';
import Header from './include/Header';
import Footer from './include/Footer';
import WhatsAppChat from './include/WhatsAppChat';

function Base({ children }) {
  const location = useLocation();

  useLayoutEffect(() => {
    destroyAllReactCarousels();
    return () => destroyAllReactCarousels();
  }, [location.pathname]);

  return (
    <>
      <Header />
      <div className="main-content">{children}</div>
      <Footer />
      <WhatsAppChat />
    </>
  );
}

export default Base;
